import { useState } from 'react';

export type ToastContext = {
  openToast: boolean;
  handleToast: (openToast: boolean) => void;
  toastMessage: string;
  setToastMessageValue: (message: string) => void;
};

const useToastContextLogic = () => {
  const [toastMessage, setToastMessage] = useState<string>();
  const [openToast, setOpenToast] = useState<boolean>(false);
  const handleToast = (isOpen) => {
    setOpenToast(isOpen);
  };
  const setToastMessageValue = (message) => {
    setToastMessage(message);
  };
  return {
    openToast,
    handleToast,
    toastMessage,
    setToastMessageValue
  };
};
export default useToastContextLogic;
